import React from 'react';
import { Button } from '../ui/button';
import { MousePointer2, Square, FileSpreadsheet, FileText, RotateCcw, Save, FolderOpen, PenSquare, Eye, EyeOff, Theater, Move, FileType } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from '../ui/dropdown-menu';

export default function Toolbar({
  selectMode,
  setSelectMode,
  onResetRemoved,
  onExportXLSX,
  onExportCSV,
  onExportPDF,
  onSave,
  onLoad,
  showHitboxes,
  setShowHitboxes,
}) {
  const ModeBtn = ({ value, icon: Icon, label, testid }) => (
    <button
      onClick={() => setSelectMode(value)}
      className={`px-3 py-1.5 rounded-full text-xs font-medium tracking-wide transition-all flex items-center gap-1.5 ${
        selectMode === value ? 'bg-stone-900 text-white shadow-sm' : 'text-stone-600 hover:text-stone-900'
      }`}
      data-testid={testid}
    >
      <Icon className="w-3.5 h-3.5" /> {label}
    </button>
  );

  return (
    <div
      className="flex items-center gap-2 px-4 py-2.5 bg-white border-b border-stone-200"
      data-testid="main-toolbar"
    >
      <div className="flex items-center bg-stone-100 rounded-full p-0.5 mr-2">
        <ModeBtn value="click" icon={MousePointer2} label="Kattintás" testid="mode-click-btn" />
        <ModeBtn value="rect" icon={Square} label="Téglalap" testid="mode-rect-btn" />
        <ModeBtn value="flex" icon={PenSquare} label="Flex rajz" testid="mode-flex-btn" />
        <ModeBtn value="stage" icon={Theater} label="Színpad" testid="mode-stage-btn" />
        <ModeBtn value="edit" icon={Move} label="Szerkesztés" testid="mode-edit-btn" />
      </div>

      <div className="h-6 w-px bg-stone-200" />

      <Button
        variant="ghost"
        size="sm"
        onClick={onResetRemoved}
        className="h-8 text-xs"
        data-testid="reset-removed-btn"
      >
        <RotateCcw className="w-3.5 h-3.5 mr-1.5" /> Visszaállít
      </Button>

      <Button
        variant="ghost"
        size="sm"
        onClick={() => setShowHitboxes(!showHitboxes)}
        className={`h-8 text-xs ${showHitboxes ? 'bg-emerald-100 text-emerald-700' : ''}`}
        data-testid="toggle-hitboxes-btn"
      >
        {showHitboxes ? <Eye className="w-3.5 h-3.5 mr-1.5" /> : <EyeOff className="w-3.5 h-3.5 mr-1.5" />}
        Hitbox
      </Button>

      <div className="flex-1" />

      <Button variant="outline" size="sm" onClick={onLoad} className="h-8 text-xs" data-testid="load-config-btn">
        <FolderOpen className="w-3.5 h-3.5 mr-1.5" /> Betöltés
      </Button>

      <Button variant="outline" size="sm" onClick={onSave} className="h-8 text-xs" data-testid="save-config-btn">
        <Save className="w-3.5 h-3.5 mr-1.5" /> Mentés
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="sm" className="h-8 text-xs bg-amber-500 hover:bg-amber-600 text-stone-900" data-testid="export-btn">
            <FileSpreadsheet className="w-3.5 h-3.5 mr-1.5" /> Export
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onExportXLSX} data-testid="export-xlsx-item">
            <FileSpreadsheet className="w-3.5 h-3.5 mr-2" /> Excel (.xlsx)
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onExportCSV} data-testid="export-csv-item">
            <FileText className="w-3.5 h-3.5 mr-2" /> CSV (.csv)
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onExportPDF} data-testid="export-pdf-item">
            <FileType className="w-3.5 h-3.5 mr-2" /> PDF (.pdf)
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
